/*Package importing*/
import React, { useState, useEffect, useRef } from 'react';

/*Import custom components and assets*/
import logo from '../../assets/images/logo.png';
import adminPic from '../../assets/images/sidebar/renna/profile.svg';
import _logout from '../../services/helper';
import FaqModal from '../modals/faqModal';
import TermsModal from '../modals/termsModal';

const Topbar = () => {
  const popupRef = useRef(null);
  const [showDropdown, setShowDropdown] = useState(false);

  const closePopup = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mouseup', closePopup);
    return () => {
      document.removeEventListener('mouseup', closePopup);
    };
  }, []); // Empty dependency array for mount/unmount only

  const handleLogout = () => {
    _logout();
  };

  return (
    <header>
      <div className="d-flex justify-content-between position-relative">
        <div className="e-header-logo-wrap">
          <img className="e-header-logo" src={logo} alt="Admin logo" />
        </div>
        <div className='d-flex align-items-center'>
          <div className='d-flex justify-content-end me-3' style={{ bottom: '5%', right: '2%' }}>
            <div className="e-backLink-wrap text-end" style={{ top: 0 }}>
              <span data-bs-toggle="modal" data-bs-target="#faq-modal">FAQ</span>
            </div>
            <div className="e-backLink-wrap text-end ms-3" style={{ top: 0 }}>
              <span onClick={() => window.open('https://click.banknizwa.om/TermsAndCondition', '_blank')}>T&C</span>
            </div>
            <div className="e-backLink-wrap text-end ms-3" style={{ top: 0 }}>
              <span onClick={() => window.open('https://www.zappit.software/eprivacy.html', '_blank')}>Privacy</span>
            </div>
          </div>
          <div className="e-admin-pic-wrap" onClick={() => setShowDropdown(!showDropdown)}>
            <img className="e-admin-pic" src={adminPic} alt="Admin Profile" />
          </div>
          {
            showDropdown ?
              <div className='e-logout-option'
                ref={popupRef}
                onClick={handleLogout}>
                Log out
              </div>
              :
              null
          }
        </div>
      </div>
      <FaqModal />
      <TermsModal />
    </header>
  );
};

export default Topbar;
